import React, {useState, useEffect, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {massUnitItem} from '../../../App';
import ConfigContext from '../../../context/configContext';
import MenuContext from '../../../context/menuContext';
import ConfigUnits from './config-unit';
import VolumeUnit from './volume-unit';
import CommandsContext from '../../../context/commandsContext';

function MassUnit() {
  const {onComponent, setDisableMenu} = useContext(MenuContext);
  const {config, onUpdate} = useContext(ConfigContext);
  const leftPress = useKeyPress('ArrowLeft');

  const onLeft = useCallback(() => {
    onComponent(<ConfigUnits />);
  }, []);

  const onRight = useCallback(
    selected => {
      onUpdate('massFlow', {...config.massFlow, unit: selected.name});
      onComponent(<VolumeUnit />);
    },
    [config],
  );

  // const onRight = selected => {
  //   onUpdate('massFlow', {...config.massFlow, unit: selected.name});
  //   onComponent(<VolumeUnit />);
  // };

  return (
    <FullBodyMenuView
      title="Select Mass Flow Unit"
      menuItems={massUnitItem}
      initialSelected={config.massFlow.unit}
      onRightCallback={onRight}
      onLeftCallback={onLeft}
    />
  );
}
export default MassUnit;
